import {createEntityThunks} from 'utils/createEntityThunks';
import {ProgramCard} from 'types/programCard';
import {ProgramCardsService} from 'services/programCardService';

const programCardFactory = (data: any) => new ProgramCard(data);

export const ProgramCardsThunks = createEntityThunks<ProgramCard>(
  'programCard',
  ProgramCardsService,
  {activate: true, deactivate: true},
  programCardFactory,
);
